import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-3">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative" data-id="element-4">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-5">
              {' '}
              <img src="https://cdn.magicpatterns.com/uploads/m5TKo3rNUFgSUaHWWJ7zsM/image.png" alt="Groupe d'élèves de taekwondo en entraînement" className="w-full h-full object-cover" data-id="element-6" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" data-id="element-7"></div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-red-600 rounded-full opacity-20 blur-2xl" data-id="element-8"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-neutral-900 rounded-full opacity-10 blur-2xl" data-id="element-9"></div>
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-10">
            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-6 leading-tight" data-id="element-11">
              Plus qu'un art martial — <br data-id="element-12" />
              <span className="text-red-600" data-id="element-13">
                une communauté qui fait grandir
              </span>
            </h2>

            <div className="space-y-6 text-lg text-neutral-600 leading-relaxed" data-id="element-14">
              <p data-id="element-15">
                Chez HLD Taekwondo, nous aidons les enfants, adolescents et
                adultes à développer leur plein potentiel à travers un
                entraînement structuré de Taekwondo.
              </p>
              <p data-id="element-16">
                Nos programmes favorisent la discipline, le respect, la
                confiance en soi et la forme physique dans un environnement
                sécuritaire et motivant.
              </p>
              <p className="font-medium text-neutral-900" data-id="element-17">
                Située à Sainte-Catherine, notre école accueille les familles de
                la Rive-Sud de Montréal avec des cours adaptés à chaque âge et
                niveau.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}